import React, { useState, useEffect, useContext } from 'react';
import Styled from 'styled-components';
import { fontQuicksand } from '../../common/mixins/mixin';
import InfoBadge from './InfoBadge';
import { computePricingInfo, amountInLocalCurrency, melaDurationMap } from '../../../../app/js_bytesize/templates/purchase/pricing-helper';
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';
import Image from '../../../../app/js/components/loggedout/common/Image';
import PurpleTick from '~images/mela-purchase/purple-tick.svg';
import { FormHeading, FormSubHeading } from "../../common/styled-components/styled-components"
import { setShowGradeSelectionPopup } from "../../actions/actions"
import { SemContext } from '../../context/SemContext';
import i18n from '../../../../app/js/utils/i18n';
import { getOrdinalCode } from '../../../../app/js/utils/web-helper';
import { setShowMorePlans } from "../../actions/actions";
import { durationListForSorting } from '../../../../app/js/utils/web-helper';
import { DURATION_MAPPING, FEATURES_DATA, YEARLY } from "./const";
import FontGraphie  from '../../../../app/js/components/loggedout/shared-styles/graphieFont';
import OrangeTickImg from "~images/sem/orange_tick.svg";
import { darkBlue, OrangeTint, white } from '../../../../app/js/components/loggedout/shared-styles/Colors';

function ProductPlan({
  products,
  activeFilterTab,
  initialDuration,
  activePlanHandler,
  selectedBox,
  selectedPlan,
  settings,
  subjectsLength,
  sortedDurationList,
  savePercentage,
  percentOffAmount
}) {
  const { state, dispatch } = useContext(SemContext)
  const { showMorePlans = false } = state;
  const productKeys = [...products.keys()];
  const sortedProductKeys = durationListForSorting.filter(val => productKeys.includes(val));
  const campaign_code = localStorage.getItem("campaign_code");
  const campaignBasedCustomMessaging = ["redemption", "splashlearn_giftup"].includes(campaign_code);
  const planHeaderText = state.settings.plan_page_header_text || "Your Plan";

  const defaultPlan = state.settings && state.settings.default_plan;
  const DEFAULT_PLAN_DURATION =
    defaultPlan && sortedDurationList.includes(defaultPlan)
      ? defaultPlan
      : sortedDurationList[0];

  let defaultProduct = products.get(DEFAULT_PLAN_DURATION);
  const showSocialNudge = settings.show_social_nudge && settings.show_social_nudge === "false" ? false : (subjectsLength > 1 && activeFilterTab.id === 'mela') || subjectsLength == 1;

  let productRelatedToPromo = null;
  let priceinfo = {};

  if (settings.showPromoPopup === 'true') {
    productRelatedToPromo = [...products.values()][0][0];
    priceinfo = computePricingInfo(productRelatedToPromo, settings);
  }
  return (
    <>
      <PlanBoxWrapper isPromoPage={settings.showPromoPage} isPromoPopup={settings.showPromoPopup}>
        {settings.showPromoPage !== true ?
          (
            <>
              { activeFilterTab && <FeatureTextContainer>
                <TickIcon>
                  <Image src={OrangeTickImg}/>
                </TickIcon>
                <FeatureText>{FEATURES_DATA[activeFilterTab.id]}</FeatureText>
              </FeatureTextContainer> }
              <FormSubHeading>Showing available plans for {i18n.t(`settings.grade.${getOrdinalCode(state.grade)}`)}. <a href="javascript:void(0);" onClick={() => changeGradeHandler(dispatch)} > change {i18n.t("grade")}</a></FormSubHeading>
            </>
          ) : settings.showPromoPopup === 'true' &&
          <>
            <FormHeading isPromoPopup={settings.showPromoPopup}>{planHeaderText}</FormHeading>
            { !campaignBasedCustomMessaging && <FormSubHeading isPromoPopup={settings.showPromoPopup}>{`Showing below is your selected ${productRelatedToPromo.display_name.toLowerCase()} plan`}</FormSubHeading> }
            { campaignBasedCustomMessaging && activeFilterTab && <FeatureTextContainer>
                <TickIcon>
                  <Image src={OrangeTickImg}/>
                </TickIcon>
                <FeatureText>{FEATURES_DATA[activeFilterTab.id]}</FeatureText>
              </FeatureTextContainer> }
          </>
        }

        {sortedProductKeys.map(
          (val) => (
            <>
              {((val === initialDuration || showMorePlans) && !campaignBasedCustomMessaging) &&
                <PlanBox
                  duration={val}
                  activeBox={initialDuration === val}
                  showMorePlans={showMorePlans}
                >
                  {initialDuration === val && <Image className="purple-tick" src={PurpleTick} />}
                  <InfoBadge
                    showSaving={val === YEARLY }
                    showSubjectNameOnSelectedTile={false && !showMorePlans && initialDuration === val}
                    subject={activeFilterTab}
                    percentOff={percentOffAmount}
                    savePercentage={savePercentage}
                    oneTimeDiscount = {true}
                    planDuration = {DURATION_MAPPING[val]}
                  // showSocialNudge={showSocialNudge} 
                  />
                  {showMorePlans && val === YEARLY && showSocialNudge ?
                    <PreferredBadge>Preferred by 80% parents</PreferredBadge> : null}
                <TitleWrapper>
                  <PlanTitle notYearlyFamilyPlan= { val === YEARLY && products.get(YEARLY) && products.get(YEARLY).length > 1}> {val}
                  {/* {" "}{(settings.showPromoPage !== true && defaultProduct && defaultProduct.length === 1 && val === YEARLY) ? (defaultProduct[0].credit_count === 1 ? <span>({defaultProduct[0].credit_count} child)</span> : <span>(Up to {defaultProduct[0].credit_count} children)</span>) : null} */}
                  </PlanTitle> 
                  {!showMorePlans && <SubjectStripe> {activeFilterTab.title} </SubjectStripe>}
                </TitleWrapper>
                  <Plan
                    product={products.get(val)}
                    tileName={val}
                    selectedPlan={selectedPlan}
                    activePlanHandler={activePlanHandler}
                    settings={settings}
                    initialDuration={initialDuration}
                  />
                </PlanBox>
              }
            </>
          )
        )}
      </PlanBoxWrapper>
      { (sortedDurationList.length > 1 || subjectsLength > 1) && !showMorePlans && <ShowMore onClick={()=>showMoreHandler(showMorePlans, dispatch)}>{showMorePlans ? 'Less Plans' : 'More Plans'}</ShowMore>}
      { settings.showRandCurrency && productRelatedToPromo && productRelatedToPromo.properties.rand_currency_text && 
        <HelperMessage>
          You can renew your { productRelatedToPromo.display_name.toLowerCase()} membership at {productRelatedToPromo.properties.rand_currency_text} billed at {priceinfo && amountInLocalCurrency(priceinfo.actualPrice, productRelatedToPromo, false, false)} after 1 {productRelatedToPromo.properties.payment_frequency_cc}.
        </HelperMessage>
      }
    </>
  );
}

const changeGradeHandler = (dispatch) => {
  trackAnalyticsEvent('Interacted Plan Purchase Combined Page', { 'Interaction Details': "Clicked Change Grade Link", 'Clicked On': 'Change Grade Link' })
  dispatch(setShowGradeSelectionPopup(true))
}

const showMoreHandler = (showMorePlans, dispatch) => {
  trackAnalyticsEvent('Interacted Plan Purchase Combined Page', { 'Interaction Details': "Clicked View More Plans", 'Clicked On': 'View More Plans' })
  const showMorePlanResp = setShowMorePlans(!showMorePlans);
  dispatch(showMorePlanResp);
}

const PriceInRand = ({product, isYearly}) => {
  return (
    <>
      {
        product.properties.rand_currency_text &&
        <PriceInLocal>
          {`${product.properties.rand_currency_text}${isYearly ? '/yr' : '/mo'}`}
          <span>{` (Approx.)`}</span>
        </PriceInLocal>
      }
    </>
  )
}

function Plan({ product, selectedPlan, tileName, activePlanHandler, settings, initialDuration }) {
  let isYearly = tileName ===  YEARLY || false;
  let { id: planId } = selectedPlan;
  //sorting products on the basis of credit count, to maintain the order
  product && product.sort((a, b) => a.credit_count - b.credit_count);

  return (
    <>
      {product.map((item) => {
        let priceinfo = computePricingInfo(item, settings);
        let { actualMonthlyPrice, actualPrice, discountedPrice, discountedMonthlyPrice, percentOff } = priceinfo;
        planId === item.id && (settings.showPromoPage === true) ? activePlanHandler(tileName, item) : null;

        return (
          <>
            {isYearly ? (settings.showPromoPage === true ? <YearlyPlans>

              <LeftInfo>
                 <ChildCount>{item.credit_count === 1 ? `1 Child` : `Up to ${item.credit_count} children`}</ChildCount> 
              </LeftInfo>
              <RightInfo pullRight={settings.showPromoPopup}>
                <Amount discount={true} showDiscount={!!percentOff}>{amountInLocalCurrency(actualPrice, item, true, true)}</Amount>
                {!!percentOff && <Amount discount={true}>{amountInLocalCurrency(discountedPrice, item, true, true)}</Amount>}
                { settings.showRandCurrency &&
                  <PriceInRand product={item} isYearly={isYearly}/>
                }
              </RightInfo>

            </YearlyPlans> :
              <YearlyPlans hideYearlyRadioBtn={product.length===1 && isYearly}>
              <input type="radio" id={item.id} onChange={() => activePlanHandler(tileName, item)} class="custom-control-input" name="yearlyPlan" checked={planId === item.id} />
              <StyledLabel class="custom-control-label" htmlFor={item.id} isYearly={isYearly} showChildCount={product.length===1 && isYearly}>
                <div>
                  {isYearly && product.length!==1 && <ChildCount>{item.credit_count === 1 ? `1 Child` : `Up to ${item.credit_count} children`}</ChildCount>}
                  {!percentOff && <PlanCost>Billed {melaDurationMap[item.access_duration].toLowerCase()} at {amountInLocalCurrency(actualPrice, item)}</PlanCost>}
                  {!!percentOff && <PlanCost>Billed for 1st {DURATION_MAPPING[melaDurationMap[item.access_duration]]} at {amountInLocalCurrency(discountedPrice, item)}</PlanCost>}
                  
                </div>
                <div>
                  <Amount showDiscount={!!percentOff}>{amountInLocalCurrency(actualMonthlyPrice, item, !percentOff && true)}</Amount>
                  {!!percentOff && <Amount discount={true}>{amountInLocalCurrency(discountedMonthlyPrice, item, true)}</Amount>}
                  {item.properties.title0 === 'family' ? <PerChild>per child</PerChild> : null}
                </div>
              </StyledLabel>
                {product.length===1 && isYearly && <OnClickWrapper onClick={() => activePlanHandler(tileName, item)}/>}
              </YearlyPlans>
            ) :

              <ShortTermPlans>
                <div>
                  {!percentOff && <PlanCost>Billed {melaDurationMap[item.access_duration].toLowerCase()} at {amountInLocalCurrency(actualPrice, item)}</PlanCost>}
                  {!!percentOff && <PlanCost>Billed for 1st {DURATION_MAPPING[melaDurationMap[item.access_duration]]} at {amountInLocalCurrency(discountedPrice, item)}</PlanCost>}
                </div>
                <div>
                  <Amount showDiscount={!!percentOff}>{amountInLocalCurrency(actualMonthlyPrice, item, !percentOff && true)}</Amount>
                  {!!percentOff && <Amount discount={true}>{amountInLocalCurrency(discountedMonthlyPrice, item, true)}</Amount>}
                  {/* {item.properties.title0==='family' ? <PerChild>per child</PerChild> : null} */}
                  { settings.showRandCurrency &&
                    <PriceInRand product={item} isYearly={isYearly}/>
                  }
                </div>
                <OnClickWrapper onClick={() => activePlanHandler(tileName, item)}/>
              </ShortTermPlans>}</>
        )
      })}
    </>
  )
}
export const PlanBoxWrapper = Styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  list-style: none;
  padding: unset;
  margin-top: ${ props => {
    if(props.isPromoPage) return "15rem";
    if(props.isPromoPopup === 'true') return "3rem";
  }}
  @media ${device.Phone}, ${device.PhoneLargeScreen} {
    margin-top: ${ props => {
      if(props.isPromoPage) return "3.7rem";
    }}
  }
`;

export const PlanBox = Styled.li`
  box-sizing: border-box;
  background-color: ${props => props.activeBox ? '#2284E2' : 'transparent'};
  border-radius: 1.2rem;
  border: 0.1rem solid ${props => props.activeBox ? '#4E9DE8' : '#4F52C3'};
  margin: ${props => props.showMorePlans ? '3.2rem' : 0} auto 0;
  padding: 1.5rem 2.6rem;
  width: 100%;
  position:relative;
  /* transition: all 0.5s ease-in-out; */
  order: ${props => props.duration === YEARLY ? 0 : 1};
  .purple-tick {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
  }
  @media ${device.PhoneLargeScreen} {
    padding: 1.5rem;
    .purple-tick {
      width: 1.6rem;
    }
  }
  @media ${device.Phone} {
    padding: 3rem 1.3rem;
    .purple-tick {
      width: 1.6rem;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 100%;
  }
`

export const YearlyPlans = Styled.div`
  text-align: left;
  margin-top: 1.2rem;
  display: flex;
  justify-content: space-between;
  input[type="radio"] {
    opacity: 0;
    width:0;
    height:0;
    ${props => props.hideYearlyRadioBtn && `display : none;`}
  }
  input[type="radio"]:checked + label::after {
    border-width: 0.4rem;
  }
`

export const Amount = Styled.span`
  text-align: right;
  align-self: center;
  ${fontQuicksand(1.8, 2.2, 7)}
  ${props => props.showDiscount &&
    `text-decoration: line-through;
      ${fontQuicksand(1.2, 1.6, 7)};
      margin-right: 1rem;
    `
  }
  ${props => props.discount &&
    `color: #A5F9E8;
    `
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.4, 2, 7)} 
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.4, 2, 7)} 
  }
`;

export const PreferredBadge = Styled.span`
  font: normal bold 1.2rem/1.6rem Quicksand;
  position: absolute;
  padding: 0.3rem 1rem;
  background-color: #A5F9E8;
  top: -2.3rem;
  left: 2.2rem;
  border-radius: 1rem 1rem 0 0;
  color: #141953;
`;

export const PlanTitle = Styled.p`
  text-align: left;
  ${props => props.notYearlyFamilyPlan ? "margin: auto 1rem;" : "margin: auto 0rem;"}
  ${fontQuicksand(2, 2.6, 7)}
  span{
    ${fontQuicksand(1.6, 2.0,'bold')}
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.6, 2, 7)}
    span{
      ${fontQuicksand(1.2, 1.6,'bold')}
    }
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.6, 2, 7)}
    span{
      ${fontQuicksand(1.2, 1.6,'bold')}
    }
  }
`;

export const ChildCount = Styled.span`
  ${fontQuicksand(1.4, 1.8, 7)}
  @media ${device.Phone} {
    ${fontQuicksand(1.3, 1.6)}
  }`;

export const PlanCost = Styled.span`
  ${fontQuicksand(1.2, 1.4, 5)}
  color: #A5F9E8;
  @media ${device.Phone} {
    ${fontQuicksand(1.1, 1.5, 7)}
  }
`;

export const StyledLabel = Styled.label`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  ${props => props.showChildCount?'padding-left: 0rem': props.isYearly? 'padding-left: 3rem':''};
  position: relative;
  &:after {
    content: '';
    opacity: ${props => (!props.isYearly || props.showChildCount) ? 0 : 1};
    width: 1.6rem;
    height: 1.6rem;
    left: 0;
    position: absolute;
    border: 0.1rem solid #fff;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: transparent;
  }
  div:first-of-type {
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const PerChild = Styled.span`
  display: block;
  text-align: right;
  ${fontQuicksand(1, 1.4, 5)};
`;

export const ShowMore = Styled.p`
  width:47rem;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  ${fontQuicksand(1.5, 2.1, 7)}
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
    ${fontQuicksand(1.3, 1.7, 7)}
  }
  @media ${device.Phone} {
    width: 34rem;
    padding: 0 1.5rem;
    ${fontQuicksand(1.3, 1.7, 7)}
  }
`;
export const ShortTermPlans = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.2rem;
`;

const LeftInfo = Styled.div`
  margin: auto 0;
`
const RightInfo = Styled.div`
  text-align: ${props => props.pullRight === 'true' ? 'right' : 'left'};
`

const HelperMessage = Styled.p `
  ${FontGraphie(1.2, 1.2, 6)}
  text-align: left;
`
const PriceInLocal = Styled.p`
  ${fontQuicksand(1.4, 1.7, 7)}
  color: #fff;
  span {
    ${fontQuicksand(1, 1.2, 7)}
  }
`;

const SubjectStripe = Styled.div`
  padding: 0.1rem 0.6rem;
  height: 1.8rem;
  color: ${darkBlue};
  background: ${OrangeTint};
  border-radius: 0.2rem;
  margin: auto 1rem;
  ${fontQuicksand(1.2,1.6,7)};
  @media ${device.Phone}{
    width: 9.1rem;
    height: 1.6rem;
    ${fontQuicksand(1.1,1.5,7)};
  }
`

const TitleWrapper = Styled.div`
  display: flex;
`

const FeatureTextContainer = Styled.div`
    margin: 0.5rem auto 1rem;
`

const TickIcon = Styled.span`
  >img{
    width: 1.3rem;
    height: 1rem;
  }
`
const FeatureText = Styled.span`
  margin-left: 0.7rem;
  color: ${white};
  ${fontQuicksand(1.4,2,5)};
  @media ${device.Phone}{
    ${fontQuicksand(1.3,1.9,5)};
  }
`

const OnClickWrapper = Styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
`;

export default ProductPlan;